module.exports = __webpack_public_path__ + "static/media/cartoes_hiper.f68a5ea1.svg";